import AppLayout from '@amzn/awsui-components-react-v3/polaris/app-layout';
import React, {useEffect, useState} from 'react';
import {appLayoutNavigationLabels} from 'src/common/labels';
import {ServiceNavigation} from 'src/components/navigation';
import 'src/styles/index.scss';
import {AppRoutes, BreadcrumbGroupWithRouter} from "src/components/common/router-common";
import {BreadcrumbGroupProps} from "@amzn/awsui-components-react-v3/polaris/breadcrumb-group/interfaces";
import {SwoUiMetrics} from "src/utils/swo-ui-metrics/swo-ui-metrics";
import {metricFeaturesList, metricPageNames} from "src/constants/swo-ui-metric-constants";
import {StartWorkflowInstanceContent} from "src/components/start-workflow-instance/start-workflow-Instance-content";
import {BulkStartWorkflowInstance} from "src/components/start-workflow-instance/bulk-start-workflow-instance";
import {Alert, Box, Button, Container, Header, Tiles} from "@amzn/awsui-components-react-v3";
import {TilesProps} from "@amzn/awsui-components-react-v3/polaris/tiles/interfaces";
import {SaveWorkflowConfig} from "src/components/start-workflow-instance/save-workflow-config";
import {StartWorkflowInstanceContentV1} from "src/components/start-workflow-instance/start-workflow-Instance-content-v1";
import {BulkStartWorkflowInstanceV1} from "src/components/start-workflow-instance/bulk-start-workflow-instance-v1";
import {SaveWorkflowInputTemplate} from "src/components/start-workflow-instance/save-workflow-input-template";


export default function StartWorkflowInstance() {

    const adhocStart: TilesProps.TilesDefinition = {
        value: 'adhoc',
        label: 'Start',
        description: 'Use this option for starting/scheduling single workflow instance.'
    }
    const bulkStart: TilesProps.TilesDefinition = {
        value: 'bulk',
        label: 'Bulk Start',
        description:
            'Use this option to start multiple workflow instance using csv file.'
    }

    const configSave: TilesProps.TilesDefinition = {
        value: 'config-save',
        label: 'Save Workflow configurations',
        description: 'Use this option if you wish to configure defaults for a program/subprogram combination.'
    }

    const items: ReadonlyArray<TilesProps.TilesDefinition> = [adhocStart, bulkStart, configSave]
    const [showAlert, setShowAlert] = useState(true);
    const [isNewVersion, setIsNewVersion] = useState(true);
    const [selectedOption, setSelectedOption] = useState<string>(adhocStart.value);
    useEffect(() => {
        SwoUiMetrics.publishCloudWatchCountMetric(metricFeaturesList.index, metricPageNames.startWorkflowInstance)
    }, [])
    const toggleVersion = () => {
        setIsNewVersion(!isNewVersion);
    };

    const renderContent = () => {
        if (isNewVersion) {
            switch(selectedOption) {
                case bulkStart.value:
                    return <Box><BulkStartWorkflowInstanceV1/></Box>;
                case adhocStart.value:
                    return <Box><StartWorkflowInstanceContentV1/></Box>;
                case configSave.value:
                    return <Box><SaveWorkflowInputTemplate/></Box>;
                default:
                    return null;
            }
        } else {
            switch(selectedOption) {
                case bulkStart.value:
                    return <Box><BulkStartWorkflowInstance/></Box>;
                case adhocStart.value:
                    return <Box><StartWorkflowInstanceContent/></Box>;
                case configSave.value:
                    return <Box><SaveWorkflowConfig/></Box>;
                default:
                    return null;
            }
        }
    };
    const bcItems: Array<BreadcrumbGroupProps.Item> = [
        {
            "text": "Home",
            "href": AppRoutes.home
        },
        {
            "text": "Workflow Instances",
            "href": AppRoutes.executionList
        },
        {
            "text": "Start Workflow Instances",
            "href": "#"
        }
    ]

    return (
        <AppLayout
            navigation={<ServiceNavigation/>}
            content={<>
                {showAlert && (
                    <>
                        {isNewVersion ? (
                            <Alert
                                data-testid="version-alert"
                                type="info"
                                onDismiss={() => setShowAlert(false)}
                                header="Welcome to the new version!"
                                action={
                                    <Button
                                        data-testid="version-switch-button"
                                        onClick={toggleVersion}
                                        variant="primary"
                                    >
                                        Switch to legacy version
                                    </Button>
                                }
                            >
                                You're using the new improved version. The legacy version will be deprecated by August 1st, 2025.
                            </Alert>
                        ) : (
                            <Alert
                                type="warning"
                                onDismiss={() => setShowAlert(false)}
                                header="Legacy Version - Deprecation Notice"
                                action={
                                    <Button
                                        onClick={toggleVersion}
                                        variant="primary"
                                    >
                                        Switch to new version
                                    </Button>
                                }
                            >
                                This is the legacy version which will be deprecated by August 1st, 2025.
                                Please switch to the new version to ensure uninterrupted service.
                            </Alert>
                        )}
                    </>
                )}

                <Container header={<Header variant={"h2"}>Please select</Header>}>
                    <Tiles
                        items={items}
                        value={selectedOption}
                        onChange={e => setSelectedOption(e.detail.value)}
                    />
                </Container>
                {renderContent()}
            </>}
            breadcrumbs={<BreadcrumbGroupWithRouter items={bcItems}/>}
            contentType="form"
            disableContentPaddings={false}
            toolsHide={true}
            ariaLabels={appLayoutNavigationLabels}
            maxContentWidth={Number.MAX_VALUE} // the main content panel will occupy the full available width.
        />
    );
}
